import { isPlainObject } from "./pathUtils";

/**
 * RFC 7396 JSON Merge Patch on a typed state object. Three states per leaf:
 *   - `undefined` / key absent → preserve the current value
 *   - `null` → set to null
 *   - value → replace
 * Plain-object leaves recurse so partial nested patches merge into the existing sub-tree.
 * Arrays and primitives replace wholesale.
 */
export function applyPatchToState<T>(state: T, patch: unknown): T {
  if (!isPlainObject(patch)) return patch === undefined ? state : (patch as T);
  if (!isPlainObject(state)) return patch as unknown as T;

  const result: Record<string, unknown> = { ...(state as Record<string, unknown>) };
  for (const key of Object.keys(patch)) {
    const patchVal = (patch as Record<string, unknown>)[key];
    if (patchVal === undefined) continue;
    const stateVal = result[key];
    result[key] = isPlainObject(patchVal) && isPlainObject(stateVal)
      ? applyPatchToState(stateVal, patchVal)
      : patchVal;
  }
  return result as T;
}
